<template>
    <div>
      <div v-if="isLoading" class="text-center text-danger my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>{{ $t('Loading...') }}</strong>
      </div>
      <b-card no-body v-if="editCurrentRow && !isLoading">
          <b-tabs pills card >
            <b-tab :title="$t('Customer')" active>
              <b-row>
                <b-col cols="12" md="12" xl="12">
                  <b-tabs pills>
                    <b-tab :title="$t('Main')" active>
                      <Main
                        ref="Main"
                        :currentRow="editCurrentRow"
                        :validation="validation"/>
                    </b-tab>
                    <b-tab :title="$t('Additional')">
                    <Additional
                      ref="Additional"
                      :userInfo="editUserInfo"
                      :additionalParams="additionalParams"
                      @makeToasts="makeToasts"/></b-tab>
                    <b-tab :title="$t('Contacts')">
                      <Contacts
                      ref="Contacts"
                      :currentRow="editCurrentRow"
                      :userInfo="editUserInfo"
                      @makeToasts="makeToasts"/>
                    </b-tab>
                    <b-tab :title="$t('Additional contacts')">
                      <AdditionalContacts
                      ref="AdditionalContacts"
                      :ceo="editCeo"
                      :accountant="editAccountant"
                      :tableContacts="editTableContacts"
                      @deleteContact="deleteContact"/>
                    </b-tab>
                    <b-tab :title="$t('Personal')">
                      <Personal
                      ref="Personal"
                      :userInfo="editUserInfo"
                      @makeToasts="makeToasts"/>
                    </b-tab>
                    <b-tab :title="$t('Groups')">
                      <Groups
                      ref="Groups"
                      :currentRow="editCurrentRow"
                      :userInfo="editUserInfo"
                      @makeToasts="makeToasts"/>
                    </b-tab>
                    <b-tab :title="$t('Other')">
                      <Other
                      ref="Other"
                      :currentRow="editCurrentRow"
                      :userInfo="editUserInfo"/>
                    </b-tab>
                    <b-tab :title="$t('Documents')">
                      <Documents
                      ref="Documents"
                      :currentRow="editCurrentRow"
                      @makeToasts="makeToasts"/>
                    </b-tab>
                    <b-tab :title="$t('Additional info')">
                      <AdditionalInfo
                      ref="AdditionalInfo"
                      :userInfo="userInfo"/>
                    </b-tab>
                    <b-row>
                      <b-col>
                        <b-button type="submit" variant="success" style="float: right; width: 120px" @click="updateUser()">{{ $t('Save') }}</b-button>
                      </b-col>
                      <b-col sm="2.5">
                        <b-button variant="secondary" style="float: right ;width: 120px" @click="undoEdit()">{{ $t('Cancel') }}</b-button>
                      </b-col>
                    </b-row>
                  </b-tabs>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab :title="$t('Tarrification')" >
              <b-row>
                <b-col cols="12" md="12" xl="12">
                  <b-tabs pills>
                    <b-tab :title="$t('Accounts')" active>
                      <b-card style="margin: 1%">
                        <Accounts
                        v-if="!editCurrentAccountInfo"
                        ref="AccountsTab"
                        :currentRow="editCurrentRow"
                        @clickOnAccount="openFullAccountInfo"
                        @refreshTable="refreshAccounts"/>
                        <FormAccount
                          ref="FormAccount"
                          v-if="editCurrentAccountInfo"
                          :accountInfo="editCurrentAccountInfo"
                          @close="editCurrentAccountInfo = null"
                          @back="editCurrentAccountInfo = null"
                          @makeToasts="makeToasts"
                          @refreshTable="refreshAccounts"/>
                      </b-card>
                    </b-tab>
                    <b-tab :title="$t('Service links')">
                      <b-card style="margin: 1%">
                        <ServiceLinks
                        ref="ServiceLinks"
                        :currentRow="editCurrentRow"
                        @makeToasts="makeToasts"/>
                      </b-card>
                    </b-tab>
                    <b-tab :title="$t('Tariff links')">
                      <b-card style="margin: 1%">
                        <TariffLinks
                        ref="TariffLinks"
                        :currentRow="editCurrentRow"
                        @refreshServiceLinks="refreshServiceLinks"
                        @makeToasts="makeToasts"/>
                      </b-card>
                    </b-tab>
                    <b-tab :title="$t('Technical parameters')">
                      <b-card style="margin: 1%">
                        <TechnicalParameters
                        ref="TechnicalParameters"
                        :currentRow="editCurrentRow"
                        @makeToasts="makeToasts"/>
                      </b-card>
                    </b-tab>
                    <b-tab :title="$t('Access cards')">
                      <AccessCards
                      ref="AccessCards"
                      :currentRow="editCurrentRow"/>
                    </b-tab>
                    <!-- <b-tab :title="$t('IPTV activation cards')">
                      <b-card style="margin: 1%">
                        <IPTVActivationCards
                        ref="IPTVActivationCards"
                        :currentRow="editCurrentRow"
                        @makeToasts="makeToasts"/>
                      </b-card>
                    </b-tab> -->
                  </b-tabs>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab :title="$t('Reports.Payments')">
              <b-row>
                <b-col cols="12" md="12" xl="12">
                  <b-tabs pills >
                    <b-tab :title="$t('Payments')" @click="reportTab = 1">
                      <b-card style="margin: 1%" v-if="reportTab == 1">
                        <ReportPayments ref="reportPayments" :dateStart="dateStart" :dateEnd="dateEnd" :filter="reportFilter" :userId="editCurrentRow.user_id" :perPage="perPage" :currentPage="currentPage" v-model="totalRows"/>
                      </b-card>
                    </b-tab>
                    <b-tab :title="$t('Internal transfer')">
                      <b-card style="margin: 1%">
                        <ReportInternalTransfer ref="reportInternalTransfer" :dateStart="dateStart" :dateEnd="dateEnd" :filter="reportFilter" :userId="editCurrentRow.user_id" :perPage="perPage" :currentPage="currentPage" v-model="totalRows"/>
                      </b-card>
                    </b-tab>
                    <b-tab :title="$t('Expiring payments')" @click="reportTab = 2">
                      <b-card style="margin: 1%" v-if="reportTab == 2">
                        <ReportExpiringPayments ref="reportExpiringPayments" :dateStart="dateStart" :dateEnd="dateEnd" :filter="reportFilter" :userId="editCurrentRow.user_id" :perPage="perPage" :currentPage="currentPage" v-model="totalRows"/>
                      </b-card>
                    </b-tab>
                    <b-tab :title="$t('Other charges')" @click="reportTab = 3">
                      <b-card style="margin: 1%" v-if="reportTab == 3">
                        <ReportOtherCharges ref="reportOtherCharges" :dateStart="dateStart" :dateEnd="dateEnd" :filter="reportFilter" :userId="editCurrentRow.user_id" :perPage="perPage" :currentPage="currentPage" v-model="totalRows"/>
                      </b-card>
                    </b-tab>
                    <b-tab :title="$t('Documents')" @click="reportTab = 4">
                      <b-card style="margin: 1%" v-if="reportTab == 4">
                        <ReportsDocuments ref="reportDocuments" :dateStart="dateStart" :dateEnd="dateEnd" :filter="reportFilter" :userId="editCurrentRow.user_id" :perPage="perPage" :currentPage="currentPage" v-model="totalRows" :selectTypeDocuments="selectTypeDocuments"/>
                      </b-card>
                    </b-tab>
                  </b-tabs>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab :title="$t('Reports.Services')">
              <b-row>
                <b-col cols="12" md="12" xl="12">
                  <b-tabs pills >
                    <b-tab :title="$t('General')" @click="reportTab = 5">
                      <b-card style="margin: 1%" v-if="reportTab == 5">
                        <ReportGeneral ref="reportGeneral" :dateStart="dateStart" :dateEnd="dateEnd" :filter="reportFilter" :userId="editCurrentRow.user_id" :perPage="perPage" :currentPage="currentPage" v-model="totalRows"/>
                      </b-card>
                    </b-tab>
                    <b-tab :title="$t('Services')" @click="reportTab = 6">
                      <b-card style="margin: 1%" v-if="reportTab == 6">
                        <ReportServices ref="reportServices" :dateStart="dateStart" :dateEnd="dateEnd" :filter="reportFilter" :userId="editCurrentRow.user_id" :perPage="perPage" :currentPage="currentPage" v-model="totalRows"/>
                      </b-card>
                    </b-tab>
                    <b-tab :title="$t('Custom charges report')">
                      <b-card style="margin: 1%">
                        <ReportCustomCharges ref="reportCustomСharges" :dateStart="dateStart" :dateEnd="dateEnd" :filter="reportFilter" :userId="editCurrentRow.user_id" :perPage="perPage" :currentPage="currentPage" v-model="totalRows"/>
                      </b-card>
                    </b-tab>
                    <b-tab :title="$t('Traffic')" @click="reportTab = 7">
                      <b-card style="margin: 1%" v-if="reportTab == 7">
                        <ReportTraffic ref="reportTraffic" :dateStart="dateStart" :dateEnd="dateEnd" :filter="reportFilter" :userId="editCurrentRow.user_id" :perPage="perPage" :currentPage="currentPage" v-model="totalRows" :selectTypeTraffic="selectTypeTraffic"/>
                      </b-card>
                    </b-tab>
                    <b-tab :title="$t('Detailed traffic')">
                      <b-card style="margin: 1%">
                        <ReportDetailedTraffic ref="reportDetailedTraffic" :dateStart="dateStart" :dateEnd="dateEnd" :filter="reportFilter" :userId="editCurrentRow.user_id" :perPage="perPage" :currentPage="currentPage" v-model="totalRows" :selectCollector="selectCollector"/>
                      </b-card>
                    </b-tab>
                    <b-tab :title="$t('TelephonyReports')" @click="reportTab = 8">
                      <b-card style="margin: 1%" v-if="reportTab == 8">
                        <ReportTelephony ref="reportTelephony" :dateStart="dateStart" :dateEnd="dateEnd" :filter="reportFilter" :userId="editCurrentRow.user_id" :perPage="perPage" :currentPage="currentPage" v-model="totalRows"/>
                      </b-card>
                    </b-tab>
                    <b-tab :title="$t('Telephony directions report')" @click="reportTab = 9">
                      <b-card style="margin: 1%" v-if="reportTab == 9">
                        <ReportTelephonyDirections ref="reportTelephonyDirections" :dateStart="dateStart" :dateEnd="dateEnd" :filter="reportFilter" :userId="editCurrentRow.user_id" :perPage="perPage" :currentPage="currentPage" v-model="totalRows"/>
                      </b-card>
                    </b-tab>
                  </b-tabs>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab :title="$t('Reports.Other')">
              <b-row>
                <b-col cols="12" md="12" xl="12">
                  <b-tabs pills >
                    <b-tab :title="$t('Blockings')" @click="reportTab = 10">
                      <b-card style="margin: 1%" v-if="reportTab == 10">
                        <ReportBlockings ref="reportBlockings" :dateStart="dateStart" :dateEnd="dateEnd" :filter="reportFilter" :userId="editCurrentRow.user_id" :perPage="perPage" :currentPage="currentPage" v-model="totalRows"/>
                      </b-card>
                    </b-tab>
                    <b-tab :title="$t('User change log')">
                      <b-card style="margin: 1%">
                        <ReportUserChangeLog ref="reportUserChangeLog" :dateStart="dateStart" :dateEnd="dateEnd" :filter="reportFilter" :userId="editCurrentRow.user_id" :perPage="perPage" :currentPage="currentPage" v-model="totalRows" :selectTypeUsers="selectTypeUsers"/>
                      </b-card>
                    </b-tab>
                    <b-tab :title="$t('Sessions')" @click="reportTab = 11">
                      <b-card style="margin: 1%" v-if="reportTab == 11">
                        <ReportSessions ref="reportSessions" :dateStart="dateStart" :dateEnd="dateEnd" :filter="reportFilter" :userId="editCurrentRow.user_id" :perPage="perPage" :currentPage="currentPage" v-model="totalRows"/>
                      </b-card>
                    </b-tab>
                    <b-tab :title="$t('DHCP lease')">
                      <b-card style="margin: 1%">
                        <ReportDHCPLease ref="reportDHCPLease" :dateStart="dateStart" :dateEnd="dateEnd" :filter="reportFilter" :userId="editCurrentRow.user_id" :perPage="perPage" :currentPage="currentPage" v-model="totalRows"/>
                      </b-card>
                    </b-tab>
                  </b-tabs>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
      </b-card>
    </div>
</template>

<script>
import axiosInstance from '@/utils/api.js'
import TableManagerBottom from '@/components/tables/TableManagerBottom'

import Main from './main/main'
import Additional from './additional/main'
import Contacts from './contacts/main'
import AdditionalContacts from './additionalContacts/main'
import Groups from './groups/main'
import AccessCards from './accessCards/main'
import Other from './others/main'
import Documents from './documents/main'
import AdditionalInfo from './additionalInfo/main'
import ServiceLinks from './serviceLinks/main'
import TariffLinks from './tariffLinks/main'
import TechnicalParameters from './technicalParameters/main'
import IPTVActivationCards from './iptvActivationCards/main'
import Personal from './personal/main'

import FormAccount from '@/pages/users/accounts/detail/main'

import ReportPayments from '@/pages/reports/payments/payments/main.vue'
import ReportInternalTransfer from '@/pages/reports/payments/internalTransfer/main.vue'
import ReportExpiringPayments from '@/pages/reports/payments/expiringPayments/main.vue'
import ReportOtherCharges from '@/pages/reports/payments/otherCharges/main.vue'
import ReportsDocuments from '@/pages/reports/payments/documents/main.vue'
import ReportGeneral from '@/pages/reports/services/general/main.vue'
import ReportServices from '@/pages/reports/services/services/main.vue'
import ReportCustomCharges from '@/pages/reports/services/customChargesReport/main.vue'
import ReportTraffic from '@/pages/reports/services/traffic/main.vue'
import ReportDetailedTraffic from '@/pages/reports/services/detailedTraffic/main.vue'
import ReportTelephony from '@/pages/reports/services/telephony/main.vue'
import ReportTelephonyDirections from '@/pages/reports/services/telephonyDirectionsReport/main.vue'
import ReportBlockings from '@/pages/reports/other/blocking/main.vue'
import ReportUserChangeLog from '@/pages/reports/other/changeLog/main.vue'
import ReportSessions from '@/pages/reports/other/sessions/main.vue'
import ReportDHCPLease from '@/pages/reports/other/dhcpLease/main.vue'
import Accounts from '@/components/tables/users/Accounts'

export default {
  components: {
    TableManagerBottom,
    Main,
    Additional,
    Contacts,
    AdditionalContacts,
    Groups,
    Other,
    Documents,
    AdditionalInfo,
    Accounts,
    ServiceLinks,
    AccessCards,
    FormAccount,
    ReportPayments,
    ReportInternalTransfer,
    ReportExpiringPayments,
    ReportOtherCharges,
    ReportsDocuments,
    ReportGeneral,
    ReportServices,
    ReportCustomCharges,
    ReportTraffic,
    ReportDetailedTraffic,
    ReportTelephony,
    ReportTelephonyDirections,
    ReportBlockings,
    ReportUserChangeLog,
    ReportSessions,
    ReportDHCPLease,
    TariffLinks,
    TechnicalParameters,
    IPTVActivationCards,
    Personal
  },
  props: {
    currentRow: null
  },
  data () {
    return {
      reportTab: 0,
      selectCollector: 0,
      selectTypeTraffic: 0,
      selectTypeUsers: 0,
      selectTypeDocuments: 1,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      is_dev: process.env.NODE_ENV === 'development',
      dateStart: new Date(),
      dateEnd: new Date(),
      reportFilter: null,
      reportFilterOptions: {
        isFilterGroup: false,
        isFilterTypeTraffic: false,
        isFilterTypeDocuments: false,
        isFilterTypeUsers: false,
        isFilterCollector: false
      },
      reportFilterOptionsDocuments: {
        isFilterGroup: false,
        isFilterTypeTraffic: false,
        isFilterTypeDocuments: true,
        isFilterTypeUsers: false,
        isFilterCollector: false
      },
      reportFilterOptionsUserChangeLog: {
        isFilterGroup: false,
        isFilterTypeTraffic: false,
        isFilterTypeDocuments: false,
        isFilterTypeUsers: true,
        isFilterCollector: false
      },
      reportFilterOptionsTraffic: {
        isFilterGroup: false,
        isFilterTypeTraffic: true,
        isFilterTypeDocuments: false,
        isFilterTypeUsers: false,
        isFilterCollector: false
      },
      reportFilterOptionsCollector: {
        isFilterGroup: false,
        isFilterTypeTraffic: false,
        isFilterTypeDocuments: false,
        isFilterTypeUsers: false,
        isFilterCollector: true
      },
      additionalParams: null,
      editAdditionalContacts: null,
      ceo: null,
      editCeo: null,
      accountant: null,
      editAccountant: null,
      tableContacts: [],
      editTableContacts: [],
      editUserInfo: null,
      userInfo: null,
      editCurrentRow: null,
      editCurrentAccountInfo: null,
      exposedContact: [],
      empertyContact: {
        'descr': '',
        'reason': '',
        'person': '',
        'person_short': '',
        'contact': '',
        'email': '',
        'id_exec_man': '0'
      },
      isLoading: true
    }
  },
  methods: {
    deleteContact (contact) {
      if (!contact) {
        return
      }
      this.editTableContacts = this.editTableContacts.filter((value) => {
        return value !== contact
      })
    },
    makeToasts (variant, body, title) {
      this.$root.$emit('makeToasts', variant, body, title)
    },
    onChangedDateStart (value) {
      this.dateStart = value
    },
    onChangedDateEnd (value) {
      this.dateEnd = value
    },
    filterChanged (value) {
      this.reportFilter = value
    },
    updateUser () {
      if (this.editCurrentRow.confirmPassword !== this.editCurrentRow.password) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Password doesn`t match'), 'Error')
        return
      }
      if (this.validation()) {
        this.exposedContact = []
        for (let i in this.editTableContacts) {
          this.exposedContact.push(this.editTableContacts[i])
        }
        this.exposedContact.push(this.editCeo, this.editAccountant)
        axiosInstance.post(this.$store.getters.API_USERS_CONTACTS + '?user_id=' + this.currentRow.user_id, this.exposedContact)

        this.editUserInfo.port_number = Number(this.editUserInfo.port_number)
        this.editUserInfo.connect_date = Number((Date.parse(this.editUserInfo.connect_date)) / 1000)
        let userFullInfo = Object.assign(this.editCurrentRow, this.editUserInfo)
        axiosInstance.put(this.$store.getters.API_USERS, userFullInfo).then((response, err) => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
            this.hideModal()
          } else {
            this.load()
            this.$root.$emit('makeToasts')
            this.$emit('refreshRow', userFullInfo.user_id)
          }
        })
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('"Login" is incorrect'), 'Error')
      }
    },
    validation () {
      if (this.editCurrentRow.login.length === 0) {
        return false
      }
      let strArray = this.editCurrentRow.login.split('')
      let goodChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@.,-_/'.split('')
      strArray = strArray.filter((value) => {
        return goodChars.includes(value)
      })
      return strArray.join('').length === this.editCurrentRow.login.length
    },
    openFullAccountInfo (row) {
      this.editCurrentAccountInfo = row
    },
    reportGeneratePayments () {
      this.$refs.reportPayments.load()
    },
    reportGenerateInternalTransfer () {
      this.$refs.reportInternalTransfer.load()
    },
    reportGenerateExpiringPayments () {
      this.$refs.reportExpiringPayments.load()
    },
    reportGenerateOtherCharges () {
      this.$refs.reportOtherCharges.load()
    },
    reportGenerateDocuments () {
      this.$refs.reportDocuments.load()
    },
    reportGenerateGeneral () {
      this.$refs.reportGeneral.load()
    },
    reportGenerateServices () {
      this.$refs.reportServices.load()
    },
    reportGenerateTraffic () {
      this.$refs.reportTraffic.load()
    },
    reportGenerateDetailedTraffic () {
      this.$refs.reportDetailedTraffic.load()
    },
    reportGenerateBlockings () {
      this.$refs.reportBlockings.load()
    },
    reportGenerateUserChangeLog () {
      this.$refs.reportUserChangeLog.load()
    },
    reportGenerateDHCPLease () {
      this.$refs.reportDHCPLease.load()
    },
    reportGenerateSessions () {
      this.$refs.reportSessions.load()
    },
    reportGenerateTelephony () {
      this.$refs.reportTelephony.load()
    },
    reportGenerateTelephonyDirections () {
      this.$refs.reportTelephonyDirections.load()
    },
    reportGenerateCustom () {
      this.$refs.reportCustomСharges.load()
    },
    async load () {
      if (this.editCurrentRow) {
        let additionalContacts = await axiosInstance.get(this.$store.getters.API_USERS_CONTACTS + '?user_id=' + this.currentRow.user_id).then(response => { return response.data })
        let tmpUserInfo = await axiosInstance.get(this.$store.getters.API_USERS_FULL_INFO + '?user_id=' + this.editCurrentRow.user_id).then(response => { return response.data })
        this.additionalParams = await axiosInstance.get(this.$store.getters.API_SETTINGS_ADDITIONAL_PARAMS).then(response => { return response.data })

        this.ceo = null
        this.accountant = null
        this.tableContacts = []

        if (Object.keys(additionalContacts).length > 0) {
          for (let i in additionalContacts) {
            if (additionalContacts[i].id_exec_man === 1) {
              this.ceo = additionalContacts[i]
            }
            if (additionalContacts[i].id_exec_man === 2) {
              this.accountant = additionalContacts[i]
            }
          }
          if (!this.ceo) {
            this.ceo = JSON.parse(JSON.stringify(this.empertyContact))
            this.ceo.id_exec_man = 1
          }
          if (!this.accountant) {
            this.accountant = JSON.parse(JSON.stringify(this.empertyContact))
            this.accountant.id_exec_man = 2
          }
          this.tableContacts = additionalContacts.filter(function (value) {
            return value.id_exec_man === 0
          })
        } else {
          this.ceo = JSON.parse(JSON.stringify(this.empertyContact))
          this.ceo.id_exec_man = 1
          this.accountant = JSON.parse(JSON.stringify(this.empertyContact))
          this.accountant.id_exec_man = 2
          this.tableContacts = []
        }
        this.additionalParams = this.additionalParams.filter(function (value, index, arr) {
          return value.visible !== false
        })
        for (let paramId in this.additionalParams) {
          let isFound = false
          for (let userParamId in tmpUserInfo.additional_params) {
            if (tmpUserInfo.additional_params[userParamId].id === this.additionalParams[paramId].id) {
              tmpUserInfo.additional_params[userParamId].display_name = this.additionalParams[paramId].display_name
              isFound = true
              break
            }
          }
          if (!isFound) {
            this.additionalParams[paramId].value = ''
            tmpUserInfo.additional_params.push(this.additionalParams[paramId])
          }
        }
        this.userInfo = tmpUserInfo
        var d = new Date(this.userInfo.connect_date * 1000)
        var month = '' + (d.getMonth() + 1)
        var day = '' + d.getDate()
        var year = d.getFullYear()

        if (month.length < 2) month = '0' + month
        if (day.length < 2) day = '0' + day
        this.userInfo.connect_date = [year, month, day].join('-')
      }
      this.isLoading = false
    },
    undoEdit () {
      this.editCurrentRow = JSON.parse(JSON.stringify(this.currentRow))
      this.editUserInfo = JSON.parse(JSON.stringify(this.userInfo))
      this.editCeo = JSON.parse(JSON.stringify(this.ceo))
      this.editAccountant = JSON.parse(JSON.stringify(this.accountant))
      this.editTableContacts = JSON.parse(JSON.stringify(this.tableContacts))
    },
    refreshAccounts () {
      this.$emit('refreshRow', this.editCurrentRow.user_id, true)
    },
    onChangedTypeDocuments (value) {
      this.selectTypeDocuments = (value)
    },
    onChangedTypeUsers (value) {
      this.selectTypeUsers = (value)
    },
    onChangedTypeTraffic (value) {
      this.selectTypeTraffic = (value)
    },
    onChangedCollector (value) {
      this.selectCollector = value
    },
    refreshServiceLinks () {
      this.$refs.ServiceLinks.reloadServices()
    }
  },
  watch: {
    ceo: function (ceo) {
      this.editCeo = JSON.parse(JSON.stringify(ceo))
    },
    accountant: function (accountant) {
      this.editAccountant = JSON.parse(JSON.stringify(accountant))
    },
    userInfo: function (val) {
      this.editUserInfo = JSON.parse(JSON.stringify(val))
    },
    tableContacts: function (val) {
      this.editTableContacts = JSON.parse(JSON.stringify(val))
    },
    currentRow: function (val) {
      this.editCurrentRow = JSON.parse(JSON.stringify(val))
      this.editCurrentAccountInfo = null
      this.load()
    }
  },
  mounted () {
    this.editCurrentRow = JSON.parse(JSON.stringify(this.currentRow))
    this.editCurrentRow.confirmPassword = JSON.parse(JSON.stringify(this.editCurrentRow.password))
    this.editCurrentAccountInfo = null
    this.load()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/main.vue